import axios from 'axios'
import { getUid } from '@/lib/role'
import { Message } from 'element-ui'

import ENV from '../env'

import longTimeApiEnum from './longTimeApiEnum'
import exportXlsEnum from './exportXlsEnum'
import router from '@/router/route'
import { getCustomCookie } from './_utils'

// export const isDev = hostname === '192.168.1.88' // 开发环境网关配置
export const isDev = ENV === 'dev' // 如果希望本地环境也调试开发环境的接口，改为true即可
// export const isDev = true
// 本地开发注释掉
// 测试环境
export const isActuallyTest = ENV === 'test'
// export const isActuallyTest = true
// 预发环境
export const isTest = ENV === 'staging'
// export const isTest = true // 如果希望开发环境也调试预发环境的接口，改为true即可
export const isProduction = ENV === 'prod'
// export const isProduction = true // 如果希望开发环境也调试生产环境的接口，改为true即可

// 本地环境临时配置
let _baseUrl = 'http://192.168.1.11'
let _baseUrlSpec = 'http://192.168.1.11'
// eslint-disable-next-line
let _apiProxyUrl = 'http://192.168.1.11:10200'

// 开发环境请求接口
if (isDev) {
  _baseUrl = 'http://192.168.1.11'
  _baseUrlSpec = 'http://192.168.1.11'
  _apiProxyUrl = 'http://192.168.1.55:10210'
  // _apiProxyUrl = 'http://gwdev.sayyoo.cn'
  // _apiProxyUrl = '188.131.143.134'
}
// 测试环境接口配置
if (isActuallyTest) {
  _apiProxyUrl = 'http://ngwtest.sayyoo.cn'
}
if (isTest) {
  // 预发环境接口配置
  _baseUrl = 'http://116.62.166.134'
  _baseUrlSpec = 'http://116.62.166.134'
  // _apiProxyUrl = 'http://testapi.sayyoo.cn'
  _apiProxyUrl = 'http://typc.sayyoo.cn'
}

// 生产环境接口配置
if (isProduction) {
  _baseUrl = 'http://120.55.42.62'
  _baseUrlSpec = 'http://121.196.207.31'
  // _apiProxyUrl = 'http://api.sayyoo.cn'
  _apiProxyUrl = 'http://pcapi.sayyoo.cn'
}
export const baseUrl = _baseUrl
export const baseUrlSpec = _baseUrlSpec
export const apiProxyUrl = _apiProxyUrl

const transformRequest = (data = {}, headers) => {
  if (typeof data === 'string' || data instanceof FormData) return data

  const loginId = getUid()

  return JSON.stringify({ ...data, loginId })
}
// axios.defaults.withCredentials = true
// 取消请求 ssf写的,超时接口用这个
var CancelToken = axios.CancelToken
let _timeOutAxios = axios.create({
  baseURL: apiProxyUrl,
  headers: {
    'Content-Type': 'application/json',
  },
  transformRequest: [transformRequest],
  timeout: 60000 * 10
})

// 请求拦截器
_timeOutAxios.interceptors.request.use(config => {
  // 请求时长10分钟
  const LONG_TIMEOUT = 1000 * 60 * 10
  if (longTimeApiEnum.some(url => config.url.includes(url))) {
    config.timeout = LONG_TIMEOUT
  }
  if (exportXlsEnum.some(url => config.url.includes(url))) {
    config.responseType = 'blob'
  }

  config.cancelToken = new CancelToken(function executor(c) {
    _timeOutAxios.cancel = c
  })
  config.headers = {
    ...config.headers,
    customCookie: getCustomCookie(),
  }
  return config
})

// 配置返回拦截器
_timeOutAxios.interceptors.response.use(
  function(response) {
    if (response.data.code === 401 || response.data.code === 40001) {
      let message =
        response.data.code === 401
          ? '身份认证已过期，请重新登录'
          : '会话失效，请重新登录'
      Message.error(message)
      setTimeout(() => {
        localStorage.clear()
        sessionStorage.clear()
        router.push({ path: '/login' })
      }, 1200)
    } else if (response.data.code === 403) {
      Message.warning('当前用户无权限执行此操作')
    }
    return response
  },
  function(error) {
    // console.log(error)
    if (error.response) {
      error.message && Message.error(error.message)
      return Promise.reject(error.response)
    } else {
      return Promise.reject(error)
    }
  }
)

export default _timeOutAxios



// WEBPACK FOOTER //
// ./src/xhr/_timeOutConfig.js